module.exports = __webpack_public_path__ + "static/media/plane2.a13b1cf8.gif";